import { isValidElement, PropsWithChildren, ReactElement } from "react";

export const extractTextFromMaybeJSX = (
  content: string | ReactElement<PropsWithChildren>
) => {
  if (typeof content === "string") {
    return content;
  }

  let extractedText = "";
  const elementsToInspect = [content];

  while (elementsToInspect.length > 0) {
    const inspectedElement: ReactElement<PropsWithChildren> | undefined =
      elementsToInspect.pop();

    if (
      inspectedElement &&
      isValidElement(inspectedElement) &&
      inspectedElement.props.children
    ) {
      const inspectedElementChildren = inspectedElement.props.children;
      if (typeof inspectedElementChildren === "string") {
        extractedText += inspectedElementChildren;
      } else {
        if (Array.isArray(inspectedElementChildren)) {
          elementsToInspect.push(
            ...(inspectedElementChildren as ReactElement<PropsWithChildren>[])
          );
        } else if (isValidElement(inspectedElementChildren as ReactElement)) {
          elementsToInspect.push(
            inspectedElementChildren as ReactElement<PropsWithChildren>
          );
        }
      }
    }
  }

  return extractedText;
};
